const labelInformacoes = {
    cnpjFornecedor: 'CNPJ',
    cpfUsuario: 'CPF',
    emailUsuario: 'Email',
    telefoneFornecedor: 'Telefone Comercial',
    logradouroFornecedor: 'Logradouro',
    numLogradouroFornecedor: 'Número do Logradouro',
    municipioFornecedor: 'Município',
    ufFornecedor: 'UF',
    razaoSocialFornecedor: 'Razão Social'
}

class ValidadorInformacoesFornecedor {

    constructor() {
        this.infoRequeridaFornecedor = [
            'cnpjFornecedor',
            'logradouroFornecedor',
            'numLogradouroFornecedor',
            'municipioFornecedor',
            'ufFornecedor',
            'razaoSocialFornecedor'
        ]
        this.infoRequeridaRepresentante = [
            'cpfUsuario',
            'emailUsuario'
        ]
    }

    validar(fornecedor) {
        const inconsistenciasFornecedor = this._verificarInconsistenciasFornecedor(fornecedor)
        const inconsistenciasRepresentante = this._verificarInconsistenciasRepresentante(fornecedor)
        const totalInconsistencias = inconsistenciasFornecedor.length + inconsistenciasRepresentante.length

        return {inconsistenciasFornecedor, inconsistenciasRepresentante, totalInconsistencias}
    }

    _verificarInconsistenciasFornecedor(fornecedor) {
        return this._verificarInconsistencias(fornecedor, this.infoRequeridaFornecedor)
    }

    _verificarInconsistenciasRepresentante(fornecedor) {
        return this._verificarInconsistencias(fornecedor, this.infoRequeridaRepresentante)
    }

    _verificarInconsistencias(fornecedor, informacoesRequeridas) {
        const inconsistencias = []
        for (const infoRequerida of informacoesRequeridas) {
            if (!fornecedor[infoRequerida]) {
                inconsistencias.push(labelInformacoes[infoRequerida])
            }
        }
        return inconsistencias
    }

}

export default new ValidadorInformacoesFornecedor()
